import React from 'react';
import CommonPageHeader from '../../../components/CommonPageHeader/CommonPageHeader';
import PageHelmet from '../../../components/shared/PageHelmet';
import MainFooter from '../../../components/MainFooter/MainFooter';
import NavHeader from '../../../components/NavHeader/NavHeader';
import KeyFeatures from '../KeyFeatures/KeyFeatures';
import OurApproach from '../../Home/OurApproach/OurApproach';
import AdditionalServices from '../AdditionalServices/AdditionalServices';
import { Proportions, LassoSelect, CopySlash, Blocks, SlidersHorizontal } from 'lucide-react';
import OurExpertise from '../../../components/OurExpertise/OurExpertise';
import { Link } from 'react-router-dom';

const OurExpertiseData = [
    {
        id: 1,
        title: "Custom CMS Development",
        icon: <SlidersHorizontal size="64" strokeWidth='1' />,
        content: "With years of experience in platforms like Drupal, WordPress, and Magento, our team excels at building scalable, tailored CMS solutions that align with your business goals."
    },
    {
        id: 2,
        title: "Third-Party Integrations",
        icon: <Blocks size="64" strokeWidth='1' />,
        content: "We specialize in seamless integration of CMS platforms with CRM, ERP, and marketing automation tools, ensuring a cohesive digital ecosystem."
    }
]

const AdditionalServicesData = [
    {
        id: 1,
        title: "Drupal",
        icon: <img src='assets/img/brand/drupal.svg' width="44px" alt="Drupal" />,
        content: "Scalable and flexible for complex content management needs, Drupal is perfect for enterprise-grade websites."
    },
    {
        id: 2,
        title: "WordPress",
        icon: <img src='assets/img/brand/wordPress.svg' width="44px" alt="WordPress" />,
        content: "Ideal for businesses of all sizes, WordPress offers versatility with its extensive plugin ecosystem and easy management."
    },
    {
        id: 3,
        title: "Magento",
        icon: <img src='assets/img/brand/magento.svg' width="44px" alt="Magento" />,
        content: "Power your e-commerce with Magento’s robust features, delivering engaging shopping experiences that drive conversions."
    }
]

const KeyFeaturesData = [
    {
        id: 1,
        title: "User-Friendly Interface",
        icon: <CopySlash size="42" strokeWidth='1' />,
        content: "Manage your content effortlessly with streamlined workflows and intuitive dashboards."
    },
    {
        id: 2,
        title: "Customization",
        icon: <LassoSelect size="42" strokeWidth='1' />,
        content: "Tailor your CMS to include unique features, integrations, and designs aligned with your brand identity."
    },
    {
        id: 3,
        title: "Scalability",
        icon: <Proportions size="42" strokeWidth='1' />,
        content: "Build a CMS that grows with your business, from expanding content types to integrating advanced features."
    },
    {
        id: 3,
        title: "Theme Design & Integration",
        icon: <Blocks size="42" strokeWidth='1' />,
        content: "We craft visually stunning designs and seamless frontend integrations to enhance user experience."
    }
]

const OurApproachData = [
    {
        id: 1,
        title: <h3><Link to="/">Discovery</Link></h3>,
        img: "assets/img/project/discover_icon_white.svg",
        content: "Understand your goals through collaborative sessions."
    },
    {
        id: 2,
        title: <h3><Link to="/">Design</Link></h3>,
        img: "assets/img/project/design_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 3,
        title: <h3><Link to="/">Development</Link></h3>,
        img: "assets/img/project/develop_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 4,
        title: <h3><Link to="/">Quality Assurance</Link></h3>,
        img: "assets/img/project/define_icon_white.svg",
        content: "Ensure flawless functionality on all devices and platforms."
    },
    {
        id: 5,
        title: <h3><Link to="/">Launch & Support</Link></h3>,
        img: "assets/img/project/deliver_icon_white.svg",
        content: "Seamless deployment, app store submissions, and ongoing maintenance."
    }
]
const bgColors = ["#006ce0", "#001133", "#006ce0", "#001133", "#006ce0"];

const CMSSolutions = () => {
    return (
        <>
            <PageHelmet
                pageTitle="CMS Solutions"
                description="Custom CMS development on WordPress, Drupal, and Magento from Harsoft Solutions, a software development company delivering scalable, easy-to-manage content platforms."
                keywords="CMS Development, WordPress Development, Drupal Development, Magento Development, Software Development Company"
                path="/CMSSolutions"
            />

            <NavHeader />
            <main>
                <CommonPageHeader title="CMS Solutions" subtitle="CMS Solutions" />
                <OurExpertise OurExpertiseData={OurExpertiseData} title="Our Expertise" subtitle="Streamline Your Digital Presence" content="We understand that effective content management is essential for success in today's digital landscape. That's why we take a holistic approach to CMS solutions, focusing not only on functionality but also on usability, scalability, and performance." />
                <KeyFeatures KeyFeaturesData={KeyFeaturesData} />
                <AdditionalServices AdditionalServicesData={AdditionalServicesData} img="assets/img/expart/expart-1.jpg" />
                <OurApproach OurApproachData={OurApproachData} title="Our Process" bgColors={bgColors} />
            </main>
            <MainFooter />
        </>
    );
};

export default CMSSolutions;
